/* unplugin-vue-components disabled */import { render } from "./sdopenUniversitymap.vue?vue&type=template&id=17f675ae&scoped=true"
import script from "./sdopenUniversitymap.vue?vue&type=script&lang=js"
export * from "./sdopenUniversitymap.vue?vue&type=script&lang=js"

import "./sdopenUniversitymap.vue?vue&type=style&index=0&id=17f675ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f675ae"]])

export default __exports__